module.exports = __webpack_public_path__ + "media/drawingSound-[AudioTrimmer.com].b1e0adba.mp3";